import { Splide } from "@splidejs/splide";

const pictureCarousels = document.querySelectorAll(".c-pictureCarousel__slider .splide");

const pictureCarouselsOptions = {
    type: "loop",
    drag: true,
    fixedWidth: "780px",
    focus: "center",
    arrows: true,
    arrowPath:
        "M 26.164 18.557 L 15.853 18.557 L 20.353 14.057 C 20.714 13.694 20.714 13.108 20.353 12.746 C 19.995 12.386 19.412 12.386 19.053 12.746 L 12.973 18.824 C 12.614 19.183 12.614 19.765 12.973 20.124 L 19.056 26.207 C 19.577 26.687 20.422 26.423 20.578 25.732 C 20.644 25.437 20.561 25.129 20.356 24.907 L 15.856 20.407 L 26.164 20.407 C 26.875 20.407 27.319 19.637 26.964 19.022 C 26.799 18.737 26.494 18.561 26.164 18.561 L 26.164 18.557 Z",
    isNavigation: false,
    pagination: false,
    updateOnMove: true,
    autoplay: true,
    interval: 5000,
    breakpoints: {
        1024: {
            arrows: false,
            fixedWidth: "80%",
        },
    },
};

pictureCarousels.forEach((el) => {
    new Splide(el, pictureCarouselsOptions).mount();
});
